import { useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { getRouteApi } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Paper } from '@gto/ui/paper'

import { useAuth } from '@/hooks/use-auth'
import { useEdgeBalance } from '@/hooks/use-edge-balance'
import { zIndex } from '@/utils/constants'

import { EdgeBalance } from './edge-balance'
import { HeaderAccountInfo } from './header-account-info'
import { HeaderAppSelector } from './header-app-selector'
import { HeaderNavigation } from './header-navigation'
import { HeaderNavigationMobile } from './header-navigation-mobile'
import { LangSelector } from './lang-selector'

const routeApi = getRouteApi('/_layout')

export const Header = () => {
  const navigate = routeApi.useNavigate()
  const isSmAndLower = useMediaQuery('down', 800)

  const { isAuthorized, user } = useAuth()
  const { balance, loading } = useEdgeBalance()
  const headerRef = useRef<HTMLDivElement>(null)

  return (
    <header
      className="fixed left-0 right-0 top-0 py-3 md:py-2"
      style={{ zIndex: zIndex.header }}
    >
      <div className="mx-auto w-full max-w-[1280px] px-6 sm:px-4">
        <Paper
          ref={headerRef}
          className="rounded-md border border-divider px-3 py-2 [@media(max-width:500px)]:-mx-2"
          elevation="3"
        >
          <div className="flex items-center justify-between gap-1 sm:gap-2">
            <div className="flex grow gap-0.5">
              <HeaderNavigationMobile />
              <HeaderAppSelector />
            </div>
            {isAuthorized && (
              <>
                <HeaderNavigation />
                {user !== null && (
                  <EdgeBalance
                    balance={balance}
                    loading={loading}
                  />
                )}
              </>
            )}
            <LangSelector />
            {isAuthorized && <HeaderAccountInfo />}
            {!isAuthorized && (
              <div className="flex items-center gap-2 sm:gap-0 xs:flex-col xs:items-stretch">
                <Button
                  color={isSmAndLower ? 'primary' : 'secondary'}
                  size="small"
                  variant={isSmAndLower ? 'contained' : 'text'}
                  onClick={() => {
                    navigate({
                      to: '/login',
                      viewTransition: true,
                    }).catch(console.error)
                  }}
                >
                  <FormattedMessage id="common.controls.login" />
                </Button>
                {!isSmAndLower && (
                  <Button
                    color="primary"
                    size="small"
                    variant="contained"
                    onClick={() => {
                      navigate({
                        to: '/signup',
                        viewTransition: true,
                      }).catch(console.error)
                    }}
                  >
                    <FormattedMessage id="common.controls.createAccount" />
                  </Button>
                )}
              </div>
            )}
          </div>
        </Paper>
      </div>
    </header>
  )
}
